enum EPhotoSourceType {
    Camera = 'camera',
    File = 'file'
}
export default EPhotoSourceType;